import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as null | string;

const slice = createSlice({
  name: 'savedUsername',
  initialState,
  reducers: {
    setSavedUsername(_state, action: PayloadAction<string>) {
      return action.payload;
    },
    removeSavedUsername(_state) {
      return null;
    },
  },
});

export const { setSavedUsername, removeSavedUsername } = slice.actions;

export default slice.reducer;
